import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import '../../theme/styles/dx-react-grid-bootstrap4.css';
import '../../theme/styles/reactstrap.css';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
var styles=require('./Report.less');
import {DropdownButton, MenuItem} from 'react-bootstrap';
import * as reportActions from './../../actions/reportActions';
import * as commonActions from './../../actions/commonActions';
 import moment from 'moment';
import '../../theme/styles/styles.css';
import '../../theme/styles/daterangepicker.css';
import '../../theme/styles/bootstraptable.css';
import * as instrumentListActions from './../../actions/instrumentListActions';
import config from './../../config.js';
import '../../theme/styles/mediaqueries.css';
import Modal from 'react-modal';
import * as filesaver from './../../actions/FileSaver';
import i18next from 'i18next';
import {Tabs, Tab, TabPanel, TabList} from 'react-web-tabs';
import renderHTML from 'react-render-html';
import { setDirection,applyStyle,applyClickActive } from './../../utils/utils';
import ReactTooltip from 'react-tooltip';
import MUIIcon from '../../components/IconMaterialUI/MUIIcon';


function formatValue(value, format) {
  if (value === null || value === undefined) return "";

  // Detect decimal places from format string (e.g., "#,###,##0.000" → 3)
  const decimalMatch = format.split(".")[1];
  const decimalPlaces = decimalMatch ? decimalMatch.length : 0;

  // Use browser locale dynamically
  return new Intl.NumberFormat(navigator.language, {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces
  }).format(value);
}

const elementsData = [
  {"classNames":"PositionfilterBar", "elementType":"tag", "applyTo":"all", "tagNames":"div"},
  {"classNames":"onlineOrdTable", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"leftPanel", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"rightPanel", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"fltrBarInner", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"reportsDropdown", "elementType":"normal", "applyTo":"all", "tagNames":"button"},
  {"classNames":"dropdown-toggle", "elementType":"normal", "applyTo":"all", "tagNames":"button"},
  {"classNames":"caret","elementType":"normal", "applyTo":"all", "tagNames":"span"},
  {"classNames":"dropdown-menu","elementType":"normal", "applyTo":"all", "tagNames":"ul"},
  {"classNames":"dropDownList","elementType":"tag", "applyTo":"all", "tagNames":"a"},
  {"classNames":"reportsTbl", "elementType":"tag", "applyTo":"all", "tagNames":"table"},
  {"classNames":"reportsTblTh", "elementType":"tag", "applyTo":"all", "tagNames":"th"},
  {"classNames":"reportsTblTd", "elementType":"normal", "applyTo":"all", "tagNames":"td"},
  {"classNames":"", "elementType":"tag", "applyTo":"all", "tagNames":"input"},
  {"classNames":"mrgnField","elementType":"normal", "applyTo":"all", "tagNames":"input"},
  {"classNames":"active","elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"fund-content","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"position-content","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"col1Label","elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"lossLmtField", "elementType":"normal", "applyTo":"single", "tagNames":"input","parent":"row"},
  {"classNames":"toolTip","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"type-dark","elementType":"normal", "applyTo":"all", "tagNames":"div"},
];
const directionData=[
  {"classNames":"dropdown-menu","elementType":"normal", "applyTo":"all", "tagNames":"ul"},
  {"classNames":"caret","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"reportsDropdown","elementType":"normal", "applyTo":"single", "tagNames":"button"},
  {"classNames":"fltrBarInner", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"exportfileBarposition", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"positionRefreshBtn", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"leftPanel", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"rightPanel", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"mrgnField","elementType":"normal", "applyTo":"all", "tagNames":"input"},
  {"classNames":"reportsTbl", "elementType":"tag", "applyTo":"all", "tagNames":"table"},
  {"classNames":"reportFundsTable", "elementType":"tag", "applyTo":"all", "tagNames":"table"},
  {"classNames":"withOrderIcon", "elementType":"tag", "applyTo":"single", "tagNames":"i"},
]
let timeCheck=Math.floor(Date.now() / 1000);
let defAccFlag = true;
let socketDataStatic=[];
@connect(state => ({clickedEdit: state.dashboardRoot.dashboardReducer.clickedEdit,
  alldealtbleData: state.dashboardRoot.reportReducer.alldealtbleData,
  reportData: state.dashboardRoot.reportReducer.reportData,
   reportPageSize: state.dashboardRoot.reportReducer.reportPageSize,
    socketDataStatic: state.dashboardRoot.instrumentListReducer.socketDataStatic,
    trdPanelData: state.dashboardRoot.instrumentListReducer.trdPanelData,
    //defAcc: state.dashboardRoot.dashboardReducer.defAcc,
    clearField:state.dashboardRoot.reportReducer.clearField,
    accBalMargBean: state.dashboardRoot.instrumentListReducer.accBalMargBean,
    positionData: state.dashboardRoot.reportReducer.positionData,
    ACD: state.auth.ACD,
    DFA: state.auth.DFA,
    loadRptFlag:state.dashboardRoot.reportReducer.loadRptFlag,
    selectedCssColorTheme:state.dashboardRoot.commonReducer.selectedCssColorTheme,
     selectedCssColor:state.dashboardRoot.commonReducer.selectedCssColor,
    localCurrency: state.dashboardRoot.instrumentListReducer.localCurrency,
    userDetail: state.auth.userDetail,
    isMarginWithOrders:state.auth.userDetail.isMarginWithOrders,
	  selectedLang:state.dashboardRoot.commonReducer.selectedLang,
    language:state.dashboardRoot.commonReducer.language,
    dropdown:state.dashboardRoot.instrumentListReducer.dropdown,
}), {
  ...reportActions,
  ...instrumentListActions,
  ...commonActions
})

export default class ReportComponent extends Component {
  static propTypes = {
    showPreview: PropTypes.object,
    reportPageSize: PropTypes.string,
    socketDataStatic: PropTypes.array,
    trdPanelData: PropTypes.object,
    getInvoice: PropTypes.func,
    accBalMargBean: PropTypes.object,
    positionData: PropTypes.object,
    getExportPositionReport: PropTypes.func,
    ACD: PropTypes.object,
    DFA: PropTypes.object,
    loadAccBalMargin:PropTypes.func,
    localCurrency: PropTypes.object,
    userDetail: PropTypes.object,
  }
  constructor(props) {
    super(props);
    this.state = {
      fromDate: '',
      toDate: '',
      Dco:[],
      CmdtyPairdata: [],
      showRptDialog: false,
      startDate: moment().format('DD-MM-YYYY'),
      endDate: moment().format('DD-MM-YYYY'),
      loadRptFlag :true,
      isRefreshDisabled:  false,
      // pageSizes: [5, 10, 15, 0],
      searchValue:'',
      detbean: [],
      fundsbean: [],
      posFunds:[],
      posPDBean:[],
      posPD:[],
      posdet:[],
      AccFlag: true,
      fromDate: '',
      toDate: '',
      PositionAcc_opt: this.props.DFA.D,
      PositionAcc_key:this.props.DFA.C,
      accountList:Array.from(this.props.ACD.values()),
      isClearAccountDash:false,
      detOrderBeanMap:[],
      detFOBeanMap:[],
      detTransitBeanMap:[],
      orderCheckbox:parseFloat(this.props.userDetail.isMarginWithOrders)===1?true:false,
      posOrderBeanMap:[],
      detUnallocBeanMap:[],
      posDetUnallocBeanMap:[],
      posDetTransitBeanMap:[],
      componentKey:"Positions",
      posFOBeanMap:[]
    }
  }
  componentDidUpdate(preProps){
    const thisComponent = ReactDOM.findDOMNode(this);
    // //const allCssStyleRules = this.props.selectedCssColorTheme;
    // applyStyle(thisComponent, allCssStyleRules, elementsData);
    // applyClickActive(thisComponent.getElementsByClassName("rwt__tab"), allCssStyleRules,"reportheader");
    setDirection(thisComponent,directionData,this.props.selectedLang);
   }
  componentWillReceiveProps(nextProps){
    // if(this.props.selectedCssColorTheme !== nextProps.selectedCssColorTheme){
    //   const thisComponent = ReactDOM.findDOMNode(this);
    //   const allCssStyleRules = nextProps.selectedCssColorTheme;
    //   applyStyle(thisComponent, allCssStyleRules, elementsData);
    //   applyClickActive(thisComponent.getElementsByClassName("rwt__tab"), allCssStyleRules,"reportheader");
    //   setDirection(ReactDOM.findDOMNode(this),directionData,this.props.selectedLang);
    // }
    if(this.state.isClearAccountDash !== this.props.isClearAccountDash){
      this.setState({ isClearAccountDash: true });
      this.setState({ loadRptFlag: true });
      this.setState({ isRefreshDisabled : true });
    }
    if(nextProps.DFA.D !== this.props.DFA.D){
        this.setState({PositionAcc_opt: nextProps.DFA.D});
        this.setState({PositionAcc_key:nextProps.DFA.C});
        this.props.loadAccBalMargin(JSON.parse(localStorage.getItem("DFA")).C,"trader",this.state.orderCheckbox);
    }
    if(nextProps.loadRptFlag !== this.props.loadRptFlag){
      if(nextProps.loadRptFlag === false){
        this.setState({loadRptFlag: nextProps.loadRptFlag});
        this.setState({ isRefreshDisabled : false });
      }
    }
    if(nextProps.updatedAccBal !== this.props.updatedAccBal){
      this.setState({loadRptFlag: false});
      this.setState({ isRefreshDisabled : false });
    }
    if(nextProps.isMarginWithOrders !== this.props.isMarginWithOrders){
      this.setState({orderCheckbox: parseFloat(nextProps.isMarginWithOrders)===1?true:false});
    }
    if(nextProps.accBalMargBean !== this.props.accBalMargBean){
      var tempdetbean=[];
      var tempfundsbean=[];
      var detOrderBeanMap=[];
      var detFOBeanMap=[];
      var detUnallocBeanMap=[];
      var detTransitBeanMap=[];
      var tempdetPhysicalBeanMap=[];

      if(nextProps.accBalMargBean?.detonlBeanMap?.size>0){
          tempdetbean = Array.from(nextProps.accBalMargBean.detonlBeanMap.values());
          for(let i=tempdetbean.length-1;i>=0;i--){
            if(parseFloat(tempdetbean[i].Q) == 0){
              tempdetbean.splice(i,1);
            }
          }
      }
      if(nextProps.accBalMargBean?.detFundsBeanMap?.size>0){
        tempfundsbean = Array.from(nextProps.accBalMargBean.detFundsBeanMap.values());
        for(let i=tempfundsbean.length-1;i>=0;i--){
          if(parseFloat(tempfundsbean[i].Q) == 0){
            tempfundsbean.splice(i,1);
          }
        }
      }
      if(nextProps.accBalMargBean?.detOrderBeanMap?.size>0){
          detOrderBeanMap = Array.from(nextProps.accBalMargBean.detOrderBeanMap.values());
          for(let i=detOrderBeanMap.length-1;i>=0;i--){
            if(parseFloat(detOrderBeanMap[i].OQ) == 0){
              detOrderBeanMap.splice(i,1);
            }
          }
      }
      if(nextProps.accBalMargBean?.detFOBeanMap?.size>0){
          detFOBeanMap = Array.from(nextProps.accBalMargBean.detFOBeanMap.values());
          for(let i=detFOBeanMap.length-1;i>=0;i--){
            if(parseFloat(detFOBeanMap[i].FQ) == 0){
              detFOBeanMap.splice(i,1);
            }
          }
      }
      if(nextProps.accBalMargBean?.detUnallocBeanMap?.size>0){
          detUnallocBeanMap = Array.from(nextProps.accBalMargBean.detUnallocBeanMap.values());
          for(let i=detUnallocBeanMap.length-1;i>=0;i--){
            if(parseFloat(detUnallocBeanMap[i].UQ) == 0){
              detUnallocBeanMap.splice(i,1);
            }
          }
        }
      if(nextProps.accBalMargBean?.detTransitBeanMap?.size>0){
          detTransitBeanMap = Array.from(nextProps.accBalMargBean.detTransitBeanMap.values());
          for(let i=detTransitBeanMap.length-1;i>=0;i--){
            if(parseFloat(detTransitBeanMap[i].TQ) == 0){
              detTransitBeanMap.splice(i,1);
            }
          }
        }

      if(nextProps.accBalMargBean?.detPhysicalBeanMap?.size>0){
          tempdetPhysicalBeanMap = Array.from(nextProps.accBalMargBean.detPhysicalBeanMap.values());
          for(let i=tempdetPhysicalBeanMap.length-1;i>=0;i--){
            if(parseFloat(tempdetPhysicalBeanMap[i].DQ) == 0){
              tempdetPhysicalBeanMap.splice(i,1);
            }
          }
      }

      this.setState({detUnallocBeanMap: detUnallocBeanMap});
      this.setState({detOrderBeanMap: detOrderBeanMap});
      this.setState({detFOBeanMap: detFOBeanMap});
      this.setState({detTransitBeanMap: detTransitBeanMap});
      this.setState({posPDBean: tempdetPhysicalBeanMap});
      this.setState({fundsbean: tempfundsbean});
      this.setState({detbean: tempdetbean});
      this.props.setLoaderFlag(false);
      this.setState({ loadRptFlag: false });
      this.setState({ isRefreshDisabled : false });
     //}
    }
    if(this.props.accBalMargBean.OQFlag!==nextProps.accBalMargBean.OQFlag){
      var componentKey=this.state.AccFlag ? nextProps.accBalMargBean.OQFlag===false ?"Positions":this.state.componentKey:nextProps.positionData.OQFlag===false?"Positions":this.state.componentKey;
      this.setState({ componentKey: componentKey });
    }
    if(this.props.accBalMargBean.FOQFlag!==nextProps.accBalMargBean.FOQFlag){
      var componentKey=this.state.AccFlag ? nextProps.accBalMargBean.FOQFlag===false ?"Positions":this.state.componentKey:nextProps.positionData.FOQFlag===false?"Positions":this.state.componentKey;
      this.setState({ componentKey: componentKey });
    }
    if(this.props.accBalMargBean.UQFlag!==nextProps.accBalMargBean.UQFlag ){
      var componentKey=this.state.AccFlag ? nextProps.accBalMargBean.UQFlag===false ?"Positions":this.state.componentKey:nextProps.positionData.UQFlag===false?"Positions":this.state.componentKey;
      this.setState({ componentKey: componentKey });
    }
    if(this.props.accBalMargBean.TQFlag!==nextProps.accBalMargBean.TQFlag){
      var componentKey=this.state.AccFlag ? nextProps.accBalMargBean.TQFlag===false ?"Positions":this.state.componentKey:nextProps.positionData.TQFlag===false?"Positions":this.state.componentKey;
      this.setState({ componentKey: componentKey });
    }
	  if (this.props.selectedLang !== nextProps.selectedLang) {
      const thisComponent = ReactDOM.findDOMNode(this);
      setDirection(ReactDOM.findDOMNode(this),directionData,nextProps.selectedLang);
    }
    if(this.props.positionData!==nextProps.positionData){
      var posfundBean=[];
      var posdetBean=[];
      var posOrderBeanMap=[];
      var posFOBeanMap=[];
      var posDetUnallocBeanMap=[];
      var posDetTransitBeanMap=[];
      let posPhysicalBean=[];
      
      if(nextProps.positionData?.detPhysicalBeanMap?.size>0){
        posPhysicalBean = Array.from(nextProps.positionData.detPhysicalBeanMap.values());
        for(let i=posPhysicalBean.length-1;i>=0;i--){
          if(parseFloat(posPhysicalBean[i].DQ) == 0){
            posPhysicalBean.splice(i,1);
          }
        }
      }
      if(nextProps.positionData?.detFundsBeanMap?.size>0)
        posfundBean = Array.from(nextProps.positionData.detFundsBeanMap.values());
      if(nextProps.positionData?.detonlBeanMap?.size>0)
        posdetBean = Array.from(nextProps.positionData.detonlBeanMap.values());
      if(nextProps.positionData?.detOrderBeanMap?.size>0)
        posOrderBeanMap = Array.from(nextProps.positionData.detOrderBeanMap.values());
      if(nextProps.positionData?.detFOBeanMap?.size>0)
        posFOBeanMap = Array.from(nextProps.positionData.detFOBeanMap.values());
      if(nextProps.positionData?.detUnallocBeanMap?.size>0)
        posDetUnallocBeanMap = Array.from(nextProps.positionData.detUnallocBeanMap.values());
      if(nextProps.positionData?.detTransitBeanMap?.size>0)
        posDetTransitBeanMap = Array.from(nextProps.positionData.detTransitBeanMap.values());
        this.setState({posOrderBeanMap: posOrderBeanMap});
        this.setState({posFOBeanMap: posFOBeanMap});
        this.setState({posFunds: posfundBean});
        this.setState({posdet: posdetBean});
        this.setState({posPD: posPhysicalBean});
        this.setState({posDetUnallocBeanMap: posDetUnallocBeanMap});
        this.setState({posDetTransitBeanMap: posDetTransitBeanMap});
        this.setState({ loadRptFlag: false });
        this.setState({ isRefreshDisabled : false });
        var componentKey=this.state.AccFlag ? this.props.accBalMargBean.OQFlag===false ?"Positions":this.state.componentKey:this.props.positionData.OQFlag===false?"Positions":this.state.componentKey;
        this.setState({ componentKey: componentKey });
    	}
    }

   componentDidMount() {
    const thisComponent = ReactDOM.findDOMNode(this);
    // //const allCssStyleRules = this.props.selectedCssColorTheme;

    // applyStyle(thisComponent, allCssStyleRules, elementsData);
    // applyClickActive(thisComponent.getElementsByClassName("rwt__tab"), allCssStyleRules);
    setDirection(ReactDOM.findDOMNode(this),directionData,this.props.selectedLang);
     var tempdetbean=[];
     var tempfundsbean=[];
     var posfundBean=[];
     var posdetBean=[];
     var detOrderBeanMap=[];
     var detFOBeanMap=[];
     var detTransitBeanMap=[];
     var detUnallocBeanMap=[];
    //  var detPhysicalBeanMap=[];
    var posPhysicalBean=[];


     if(this.props.positionData?.detPhysicalBeanMap?.size>0){
        posPhysicalBean = Array.from(this.props.positionData.detPhysicalBeanMap.values());
        // for(let i=detPhysicalBeanMap.length-1;i>=0;i--){
        //   if(parseFloat(detPhysicalBeanMap[i].DQ) == 0){
        //     detPhysicalBeanMap.splice(i,1);
        //   }
        // }
      }
      // this.setState({detPhysicalBeanMap: detPhysicalBeanMap});


     if(this.props.positionData?.detFundsBeanMap?.size>0)
        posfundBean = Array.from(this.props.positionData.detFundsBeanMap.values());
     if(this.props.positionData?.detonlBeanMap?.size>0)
        posdetBean = Array.from(this.props.positionData.detonlBeanMap.values());
     if(this.props.accBalMargBean?.detonlBeanMap?.size>0){
        tempdetbean = Array.from(this.props.accBalMargBean.detonlBeanMap.values());
        for(let i=tempdetbean.length-1;i>=0;i--){
          if(parseFloat(tempdetbean[i].Q) == 0){
            tempdetbean.splice(i,1);
          }
        }
      }
      if(this.props.accBalMargBean?.detOrderBeanMap?.size>0){
          detOrderBeanMap = Array.from(this.props.accBalMargBean.detOrderBeanMap.values());
          for(let i=detOrderBeanMap.length-1;i>=0;i--){
            if(parseFloat(detOrderBeanMap[i].OQ) == 0){
              detOrderBeanMap.splice(i,1);
            }
          }
      }
      this.setState({detOrderBeanMap: detOrderBeanMap});
      if(this.props.accBalMargBean?.detFOBeanMap?.size>0){
          detFOBeanMap = Array.from(this.props.accBalMargBean.detFOBeanMap.values());
          for(let i=detFOBeanMap.length-1;i>=0;i--){
            if(parseFloat(detFOBeanMap[i].FQ) == 0){
              detFOBeanMap.splice(i,1);
            }
          }
      }
      this.setState({detFOBeanMap: detFOBeanMap});
      if(this.props.accBalMargBean?.detTransitBeanMap?.size>0){
          detTransitBeanMap = Array.from(this.props.accBalMargBean.detTransitBeanMap.values());
          for(let i=detTransitBeanMap.length-1;i>=0;i--){
            if(parseFloat(detTransitBeanMap[i].TQ) == 0){
              detTransitBeanMap.splice(i,1);
            }
          }
        }
      if(this.props.accBalMargBean?.detUnallocBeanMap?.size>0){
          detUnallocBeanMap = Array.from(this.props.accBalMargBean.detUnallocBeanMap.values());
          for(let i=detUnallocBeanMap.length-1;i>=0;i--){
            if(parseFloat(detUnallocBeanMap[i].UQ) == 0){
              detUnallocBeanMap.splice(i,1);
            }
          }
        }

      this.setState({detTransitBeanMap: detTransitBeanMap});
      this.setState({detUnallocBeanMap: detUnallocBeanMap});
     if(this.props.accBalMargBean?.detFundsBeanMap?.size>0)
        tempfundsbean = Array.from(this.props.accBalMargBean.detFundsBeanMap.values());
     this.setState({fundsbean: tempfundsbean});
     this.setState({detbean: tempdetbean});
     this.setState({posFunds: posfundBean});
     this.setState({posdet: posdetBean});
     this.setState({posPD: posPhysicalBean})
     //this.setState({accCode: this.state.accountList[0].C});
     this.setState({ loadRptFlag: true });
     this.setState({ isRefreshDisabled : true });
       try {
           this.setState({ loadRptFlag: true });
           this.setState({ isRefreshDisabled : true });
           if (this.props.DFA.C !== this.state.PositionAcc_key) {
             this.props.setLoaderFlag(true);
             this.chnageAccPos(this.state.PositionAcc_key,this.state.orderCheckbox);
           }
           //else {
           //  this.props.updateAccBal(this.state.PositionAcc_key);
           // }
         }
         catch (e) {
           console.log(e);
         }
     }

  componentWillMount() {
  const locale = locale;
  this.setState({
      locale: {
          'format': 'DD-MM-YYYY'
      },
      });
 }
 exportSelection = (event) => {
  try{
    const start = new Date(this.state.startDate).toLocaleDateString('en-GB');
    const end = new Date(this.state.endDate).toLocaleDateString('en-GB');
    this.props.getExportPositionReport(this.state.PositionAcc_key,this.state.PositionAcc_opt,this.state.orderCheckbox);
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'exportSelection', component:"AccountDashboard"});
  }
 }

 // handleEvent = (event, picker) => {
 //   this.setState({startDate: picker.startDate.format('DD-MM-YYYY'), endDate: picker.endDate.format('DD-MM-YYYY')});
 //   }

 chnageAccPos(key,orderCheckbox) {
  try{
    const user = JSON.parse(localStorage.getItem('user'));
    this.props.ChnageAccount(key,user.UID,orderCheckbox);
    if((Math.floor(Date.now() / 1000)-timeCheck>31)){
      timeCheck=Math.floor(Date.now() / 1000);
        if (defAccFlag === false) {
          setTimeout(() => {
            this.chnageAccPos(this.state.selectAct,this.state.orderCheckbox);
          }, 30000);
        }
    }
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'chnageAccPos', component:"AccountDashboard"});
  }
 }
 selectedComponent = (compntkey) => {
  try{
   this.setState({componentKey : compntkey});
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'selectedComponent', component:"AccountDashboard"});
  }
 }
 PositionAcc_opt = (text, key) => {
   try {
     this.props.setLoaderFlag(true);
    // this.setState({ loadRptFlag: true });
    //  this.setState({ isRefreshDisabled : true });
     this.setState({PositionAcc_opt: text});
     this.setState({PositionAcc_key:key});
     if (this.props.DFA.C !== key) {
       defAccFlag = false;
       this.setState({AccFlag: false});
       this.chnageAccPos(key,this.state.orderCheckbox);
       this.setState({selectAct:key});
       //this.setState(defAccFlag:false);
     } else {
       defAccFlag = true;
       this.setState({selectAct:key});
       this.setState({AccFlag: true});
       this.props.loadAccBalMargin(JSON.parse(localStorage.getItem("DFA")).C,"trader",this.state.orderCheckbox);
   //    this.setState(defAccFlag:true);
     }
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'PositionAcc_opt', component:"AccountDashboard"});
  }
 }
 refreshAccDashboard = () => {
   //  console.log(event.key.text);
   try {
       this.setState({ loadRptFlag: true });
       this.setState({ isRefreshDisabled : true });
     if (this.props.DFA.C !== this.state.PositionAcc_key) {
       this.props.setLoaderFlag(true);
       this.chnageAccPos(this.state.PositionAcc_key,this.state.orderCheckbox);
     } else {
       this.props.loadAccBalMargin(this.state.PositionAcc_key,"trader",this.state.orderCheckbox);
     }
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'refreshAccDashboard', component:"AccountDashboard"});
  }
 }
 getDecimal=(CmdtyPair)=>{
  try{
    var dec;
    for (let index = 0; index <this.props.socketDataStatic.length; index++) {
    if (this.props.socketDataStatic[index].ID.replace("-", "") === CmdtyPair) {
      dec = this.props.socketDataStatic[index].dec;
      break;
      }
    }
    return dec;
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'getDecimal', component:"AccountDashboard"});
  }
 }
 getDec=(CmdtyPair)=>{
  try{
    var dec;
    for (let index = 0; index <this.props.socketDataStatic.length; index++) {
      if(this.props.socketDataStatic[index].D1===CmdtyPair && this.props.socketDataStatic[index].C === 1){
        dec=this.props.socketDataStatic[index].dec;
        break;
      }else if(this.props.socketDataStatic[index].D1===CmdtyPair && this.props.socketDataStatic[index].C === 4){
        dec=this.props.socketDataStatic[index].dec;
        break;
      }
    }
    return dec;
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'getDec', component:"AccountDashboard"});
  }
 }
 orderCheckboxChange = (event) => {
  try{
    this.setState({ orderCheckbox: event.target.checked});
     this.props.setLoaderFlag(true);
     if (this.props.DFA.C !== this.state.PositionAcc_key) {
       //defAccFlag = false;
       this.setState({AccFlag: false});
       this.chnageAccPos(this.state.PositionAcc_key,event.target.checked);
       this.setState({selectAct:this.state.PositionAcc_key});
       //this.setState(defAccFlag:false);
     } else {
       //defAccFlag = true;
       this.setState({selectAct:this.state.PositionAcc_key});
       this.setState({AccFlag: true});
       this.props.loadAccBalMargin(JSON.parse(localStorage.getItem("DFA")).C,"trader",event.target.checked);
   //    this.setState(defAccFlag:true);
     }
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'orderCheckboxChange', component:"AccountDashboard"});
  }
 }
render() {
  const { type, startDate, endDate, exportSelection,  accCode,  cmdtyKey  } = this.state;
  const {PositionAcc_opt} = this.state;
  let c=0;
  let lengthPos=this.state.AccFlag ? this.state.detbean.length : this.state.posdet.length;
  let cntPos = 7;
  let blankTDPos = '';
  for(let i=this.state.detbean.length; i<=parseInt(cntPos - lengthPos); i++) {
      blankTDPos += "<tr style='background:" 
      + "'> <td></td><td></td> <td></td> <td></td> </tr>";

    }

  let lengthOrd = this.state.AccFlag ? this.props.accBalMargBean.OQFlag === true ?  this.state.detbean.length : 0 : this.props.accBalMargBean.OQFlag === true ? this.props.positionData.detOrderBeanMap.length : 0;
  let cntOrd = 7;
  let blankTDOrd = '';
  for(let i=this.state.detOrderBeanMap.length; i<=parseInt(cntOrd - lengthOrd); i++) {
      blankTDOrd += "<tr style='background:"  + "'> <td></td><td></td><td></td><td></td> </tr>";
   }

   let lengthFO = this.state.AccFlag ? this.props.accBalMargBean.FOQFlag === true ?  this.state.detbean.length : 0 : this.props.accBalMargBean.FOQFlag === true ? this.props.positionData.detFOBeanMap.length : 0;
   let cntFO = 7;
   let blankTDFO = '';
   for(let i=this.state.detFOBeanMap.length; i<=parseInt(cntFO - lengthFO); i++) {
       blankTDFO += "<tr style='background:" + "'> <td></td><td></td><td></td><td></td> </tr>";
    }

  let lengthTransit=this.state.AccFlag ? this.props.accBalMargBean.TQFlag === true ? this.state.detTransitBeanMap.length : 0: this.props.positionData.TQFlag === true ? this.props.positionData.detTransitBeanMap.length: 0;
  let cntTransit = 7;
  let blankTDTransit = '';
  for(let i=lengthTransit; i<=parseInt(cntTransit - lengthTransit); i++) {
      blankTDTransit += "<tr style='background:" + "'> <td></td><td></td><td></td> <td></td> </tr>";
   }

  let lengthUnallocate=this.state.AccFlag ? this.props.accBalMargBean.UQFlag === true ?  this.state.detUnallocBeanMap.length : 0 : this.props.positionData.UQFlag === true ? this.props.positionData.detUnallocBeanMap.length : 0;
  let cntUnallocated = 7;
  let blankTDUnallocate = '';
  for(let i=lengthUnallocate; i<=parseInt(cntUnallocated - lengthUnallocate); i++) {
      blankTDUnallocate += "<tr style='background:" + "'><td></td><td></td><td></td><td></td></tr>";
   }

  let lengthfund= this.state.fundsbean.length;
  let cntFund = 7;
  let blankTDfund = '';
  for(let i=lengthfund; i<=parseInt(cntFund - lengthfund); i++) {
      blankTDfund += "<tr style='background:" + "'><td></td><td></td></tr>";
  }

  let totFundsArray;
  let totrevalArray;
  let netEquityArray;
  let lossLimitArray;
  let lossLimitfloat;
  let tempMaArray;
  let excessArray;
  let nopArray;
  let nopLimitArray;
  let applMrgArray;
  let totFundsfloat;
  let totrevalfloat;
  let netEquityfloat;
  let tempMafloat;
  let excessfloat;
  let nopfloat;
  let applMrgfloat;
  let totMarginPerc;
  let mrgcheckValue;
  if (this.state.AccFlag !== true && this.props.positionData.totFunds !== null) {
    totFundsArray = Number((parseFloat(this.props.positionData.totfunds)).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF });
    totFundsfloat= Number((parseFloat(this.props.positionData.totfunds)).toFixed(config.AmountRoundOFF));
    totrevalArray = Number((parseFloat(this.props.positionData.totReval)).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF });
    totrevalfloat= Number((parseFloat(this.props.positionData.totReval)).toFixed(config.AmountRoundOFF));
    netEquityArray = Number((parseFloat(this.props.positionData.totReval) + parseFloat(this.props.positionData.totfunds)).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF });
    netEquityfloat=Number((parseFloat(this.props.positionData.totReval) + parseFloat(this.props.positionData.totfunds)).toFixed(config.AmountRoundOFF));
    tempMaArray = Number((parseFloat(this.props.positionData.totMargin)).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF });
    tempMafloat=Number((parseFloat(this.props.positionData.totMargin)).toFixed(config.AmountRoundOFF));
    excessArray = Number(parseFloat(this.props.positionData.excess).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF });
    excessfloat=Number(parseFloat(this.props.positionData.excess).toFixed(config.AmountRoundOFF));
    applMrgArray = Number((parseFloat(this.props.positionData.totmargin)).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF });
    applMrgfloat=Number((parseFloat(this.props.positionData.totmargin)).toFixed(config.AmountRoundOFF));
    totMarginPerc=Number(parseFloat(this.props.positionData.margPerc).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF });
    lossLimitArray = Number((parseFloat(this.props.positionData.lossLmt)).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF });
    lossLimitfloat=Number((parseFloat(this.props.positionData.lossLmt)).toFixed(config.AmountRoundOFF));
    let marginPerc =Number(parseFloat(this.props.positionData.margPerc).toFixed(config.AmountRoundOFF));
    if(isNaN(this.props.positionData.margPerc)){
      totMarginPerc=this.props.positionData.margPerc;
      if(marginPerc>0){
        mrgcheckValue=true;
      }else{
        mrgcheckValue=false;
      }
    }
    else{
        if(marginPerc>0){
            mrgcheckValue=true;
        }else{
          mrgcheckValue=false;
        }
        totMarginPerc=totMarginPerc+" %";
    }
  } else {

    totFundsArray = this.state.orderCheckbox===true? Number((parseFloat(this.props.accBalMargBean.totfunds)).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF })
    : Number((parseFloat(this.props.accBalMargBean.noOrdtotfunds)).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF });
    totFundsfloat=this.state.orderCheckbox===true? Number((parseFloat(this.props.accBalMargBean.totfunds)).toFixed(config.AmountRoundOFF))
    : Number((parseFloat(this.props.accBalMargBean.noOrdtotfunds)).toFixed(config.AmountRoundOFF));
    totrevalArray = this.state.orderCheckbox===true? Number((parseFloat(this.props.accBalMargBean.totReval)).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF })
    : Number((parseFloat(this.props.accBalMargBean.noOrdtotReval)).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF });
    totrevalfloat=this.state.orderCheckbox===true? Number((parseFloat(this.props.accBalMargBean.totReval)).toFixed(config.AmountRoundOFF))
    : Number((parseFloat(this.props.accBalMargBean.noOrdtotReval)).toFixed(config.AmountRoundOFF));
    netEquityArray = this.state.orderCheckbox===true? Number((parseFloat(this.props.accBalMargBean.totReval) + parseFloat(this.props.accBalMargBean.totfunds)).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF })
    : Number((parseFloat(this.props.accBalMargBean.noOrdtotReval) + parseFloat(this.props.accBalMargBean.noOrdtotfunds)).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF });
    netEquityfloat=this.state.orderCheckbox===true? Number((parseFloat(this.props.accBalMargBean.totReval) + parseFloat(this.props.accBalMargBean.totfunds)).toFixed(config.AmountRoundOFF))
    : Number((parseFloat(this.props.accBalMargBean.noOrdtotReval) + parseFloat(this.props.accBalMargBean.noOrdtotfunds)).toFixed(config.AmountRoundOFF));
    excessArray = this.state.orderCheckbox===true? Number((parseFloat(this.props.accBalMargBean.excess)).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF })
    : Number((parseFloat(this.props.accBalMargBean.noOrdexcess)).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF });
    excessfloat=this.state.orderCheckbox===true? Number(parseFloat(this.props.accBalMargBean.excess).toFixed(config.AmountRoundOFF))
    :Number(parseFloat(this.props.accBalMargBean.noOrdexcess).toFixed(config.AmountRoundOFF));
    applMrgArray = this.state.orderCheckbox===true? Number((parseFloat(this.props.accBalMargBean.totmargin)).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF })
    : Number((parseFloat(this.props.accBalMargBean.noOrdtotmargin)).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF });
    applMrgfloat=this.state.orderCheckbox===true? Number((parseFloat(this.props.accBalMargBean.totmargin)).toFixed(config.AmountRoundOFF))
    : Number((parseFloat(this.props.accBalMargBean.noOrdtotmargin)).toFixed(config.AmountRoundOFF));
    totMarginPerc=this.state.orderCheckbox===true? Number(parseFloat(this.props.accBalMargBean.margPerc)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF, maximumFractionDigits:config.AmountRoundOFF})
    : Number(parseFloat(this.props.accBalMargBean.noOrdmargPerc)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF,maximumFractionDigits:config.AmountRoundOFF });
    lossLimitArray = Number((parseFloat(this.props.accBalMargBean.lossLimit)).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF });
    lossLimitfloat=Number((parseFloat(this.props.accBalMargBean.lossLimit)).toFixed(config.AmountRoundOFF));
    let marginPerc =this.state.orderCheckbox===true? Number(parseFloat(this.props.accBalMargBean.margPerc).toFixed(config.AmountRoundOFF)):
    Number(parseFloat(this.props.accBalMargBean.noOrdmargPerc).toFixed(config.AmountRoundOFF))
    if(marginPerc>0){
        mrgcheckValue=true;
    }else{
      mrgcheckValue=false;
    }
    totMarginPerc=totMarginPerc+" %";
  }
  var percLable=this.state.AccFlag ?
  this.props.accBalMargBean.margPercLable:this.props.positionData.margPercLable;
  let marginPerCentValue=i18next.t('marginAmt') +" @ "+Number(parseFloat(percLable)).toLocaleString(navigator.language) + "%";
  let Excess=excessArray>"0"? i18next.t('excess') : i18next.t('short');
  //console.log("lossLimitfloat "  + lossLimitfloat);
  return (
    <div>
      {this.state.orderCheckbox===true?<ReactTooltip class='toolTip' id='withOrdTooltip' destroyTooltipOnHide={true} delayShow={10} getContent={[()=> (<span>{i18next.t('withOrderTooltip')}</span>),1000]}/>:null}
		<div className={`${styles.PositionfilterBar} PositionfilterBar ${this.props.selectedCssColor} ${this.props.language}`}>
			<div className={`${styles.PositionfilterBarInner} col-xs-12 fltrBarInner`}>
				<div className={styles.filterItemcompPosition} id="PoskeepingAccList">
					<DropdownButton title={i18next.t(PositionAcc_opt)} id="bg-nested-dropdown" className={`${styles.PoskeepingAcc} reportsDropdown`}>
					{this.state.accountList.map((item) => {
						return (
							<MenuItem onClick={() => this.PositionAcc_opt(item.D, item.C)} id="rptPosAccListMenu">{item.D}</MenuItem>
						);
					})
					}
					</DropdownButton>
				</div>
        {this.props.userDetail.enableCustomerOrder ?
          <div className={styles.considerOrdCheckbox}>
            <label className={`${styles.containerClass} cust-box`}><input type="checkbox" className={styles.column1_checkbox} checked={this.state.orderCheckbox} onChange={this.orderCheckboxChange}/><span class="checkmark"></span></label>
            <label className={`${styles.column1_lbl} col1Label`} >{i18next.t('considerOrdInMrgnCal')}</label>
          </div>:null}
				<div className={`${styles.exportfileBarposition} exportfileBarposition`}>
					<div id="positionRefreshBtn" className={`positionRefreshBtn`}>
						<button type="button" className={this.state.isRefreshDisabled === true ? `${styles.disabled} ${styles.goBtn}` : `${styles.goBtn}`} onClick={this.refreshAccDashboard} id="rptRefreshBtn">{this.props.refreshIcon}</button>
					</div>
					<label className={this.state.loadRptFlag === true ? "disableLabel" : null}>
						<span><img src="/images/pdf.png" onClick={this.exportSelection} id="rptExportImg"/></span>
					</label>
				</div>
			</div>
        </div>
        <div className={`${styles.onlineOrdTable} onlineOrdTable ${this.props.language}`}>
            {this.state.loadRptFlag === true ?
                <div className={styles.rptoverlay1} >
                    <i className="fa fa-spinner fa-spin spin-big"></i>
                </div>
            : null}
            <div className={`${styles.leftpositionpanel} leftPanel`} id="leftdivPosition">
              <Tabs defaultTab={this.state.componentKey} onChange={this.selectedComponent}>
                  <TabList>
                      <Tab tabFor="Positions" className="rwt_horizontal__tab tabName active">{i18next.t('positions')}</Tab>
                      <Tab tabFor="Funds" className="rwt_horizontal__tab tabName">{i18next.t('funds')}</Tab>
                      {this.props.userDetail.enableCustomerOrder && this.state.AccFlag ? this.props.accBalMargBean.OQFlag===true ? <Tab tabFor="Orders" className="rwt_horizontal__tab tabName">{i18next.t('orders')}</Tab>
                      :null:this.props.userDetail.enableCustomerOrder && this.props.positionData.OQFlag===true?<Tab tabFor="Orders" className="rwt_horizontal__tab tabName">{i18next.t('orders')}</Tab>:null}
                      {this.props.userDetail.enableFXOrd && this.state.AccFlag ? this.props.accBalMargBean.FOQFlag===true ? <Tab tabFor="Fix" className="rwt_horizontal__tab tabName">{i18next.t('fix')}</Tab>
                      :null:this.props.userDetail.enableFXOrd && this.props.positionData.FOQFlag===true?<Tab tabFor="Fix" className="rwt_horizontal__tab tabName">{i18next.t('fix')}</Tab>:null}
                      {this.state.AccFlag ? this.props.accBalMargBean.UQFlag===true ? <Tab tabFor="Unallocated" className="rwt_horizontal__tab tabName">{i18next.t('unallocated')}</Tab>
                      :null:this.props.positionData.UQFlag===true?<Tab tabFor="Unallocated" className="rwt_horizontal__tab tabName">{i18next.t('unallocated')}</Tab>:null}
                      {this.state.AccFlag ? this.props.accBalMargBean.TQFlag===true ? <Tab tabFor="Transit" className="rwt_horizontal__tab tabName">{i18next.t('transit')}</Tab>
                      :null:this.props.positionData.TQFlag===true?<Tab tabFor="Transit" className="rwt_horizontal__tab tabName">{i18next.t('transit')}</Tab>:null}
                      {this.props.userDetail.isPhysicalDeliveryEnabled && (this.state.AccFlag ? this.state.posPDBean.length : this.state.posPD.length) ? <Tab tabFor="Delivery" className="rwt_horizontal__tab tabName">{i18next.t('delivery')}</Tab>:null}
                  </TabList>
                  <div>
        						<TabPanel tabId="Positions" className="position-content">
        							<div className="table-responsive">
        								<table id="ordertbl" className="reportsTbl">
        									<thead>
        										<tr>
        											<th className="reportsTblTh">{i18next.t('type')}</th>
        											<th className="reportsTblTh">{i18next.t('balance')}</th>
        											<th className="reportsTblTh">{i18next.t('price')}</th>
        											<th className="reportsTblTh">{i18next.t('currentVal')}</th>
        										</tr>
        									</thead>
        									<tbody>
        										{this.state.AccFlag?this.state.detbean.map((item, index) => {
                              var dec=item.INSTID?this.getDecimal(item.INSTID):this.getDec(item.D);
                              if(item.INSTID !== ""){
        												return (
        													<tr >
        														<td className="reportsTblTd">{this.props.dropdown.cmdty_metal.indexOf(item.D) !== -1 ? item.D + " " + this.props.userDetail.CompanyBaseName :item.D}</td>
        														<td className="reportsTblTd">{Number(parseFloat(item.Q).toFixed(config.QuantityRoundOff)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })}</td>
        														<td className="reportsTblTd">{item.STK_VAL.tick ? Number(item.STK_VAL.tick).toLocaleString(navigator.language,{ minimumFractionDigits: dec, maximumFractionDigits: dec }) : null}</td>
        														<td className="reportsTblTd">{Number(parseFloat(item.STK_VAL.RA).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF })}</td>
        													</tr>
        												);
                              }
        										}): this.state.posdet.map((item, index) => {
                            var dec=this.getDec(item.suf_desc);
        										if(Number(parseFloat(item.fc_amt).toFixed(config.QuantityRoundOff)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff }) != 0.0){
        										return (
        											<tr >
        												<td className="reportsTblTd">{this.props.dropdown.cmdty_metal.indexOf(item.suf_desc) !== -1 ? item.suf_desc + " " + this.props.userDetail.CompanyBaseName :item.suf_desc}</td>
        												<td className="reportsTblTd">{Number(parseFloat(item.fc_amt).toFixed(config.QuantityRoundOff)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })}</td>
        												<td className="reportsTblTd">{Number(item.rate).toLocaleString(navigator.language,{ minimumFractionDigits: dec, maximumFractionDigits: dec })}</td>
        												<td className="reportsTblTd">{Number(parseFloat(item.amt).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF })}</td>
        											</tr>
        										);
        										}
        										})}
        										{renderHTML(blankTDPos)}
        									</tbody>
        								</table>
        							</div>
                    </TabPanel>
                    {this.state.AccFlag ?
        						this.props.accBalMargBean.OQFlag === true
        						? <TabPanel tabId="Orders" className="position-content">
        							<table id="ordertbl" className="reportsTbl">
        								<thead>
        									<tr>
                            <th className="reportsTblTh">{i18next.t('type')}</th>
                            <th className="reportsTblTh">{i18next.t('balance')}</th>
                            <th className="reportsTblTh">{i18next.t('price')}</th>
                            <th className="reportsTblTh">{i18next.t('currentVal')}</th>
        									</tr>
        								</thead>
        								<tbody>
        									{this.state.detOrderBeanMap.map((item, index) => {
                            var dec=item.INSTID?this.getDecimal(item.INSTID):this.getDec(item.D);
        										return (
        											<tr >
        												<td className="reportsTblTd">{this.props.dropdown.cmdty_metal.indexOf(item.D) !== -1 ? item.D + " " + this.props.userDetail.CompanyBaseName :item.D}</td>
        												<td className="reportsTblTd">{Number(parseFloat(item.OQ).toFixed(config.QuantityRoundOff)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })}</td>
                                						<td className="reportsTblTd">{Number(item.STK_VAL.tick).toLocaleString(navigator.language,{ minimumFractionDigits: dec, maximumFractionDigits: dec })}</td>
        												<td className="reportsTblTd">{Number(parseFloat(item.STK_VAL.RO).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF })}</td>
        											</tr>
        										);
        									})
        									}
        									{renderHTML(blankTDOrd)}
        									{/* {converter.convert(blankTDOrd)} */}
        								</tbody>
        							</table>
                    </TabPanel>
        						: <TabPanel tabId="Orders" className="position-content">
        							<table id="ordertbl" className="reportsTbl">
        								<thead>
        									<tr>
                            <th className="reportsTblTh">{i18next.t('type')}</th>
                            <th className="reportsTblTh">{i18next.t('balance')}</th>
                            <th className="reportsTblTh">{i18next.t('price')}</th>
                            <th className="reportsTblTh">{i18next.t('currentVal')}</th>
        									</tr>
        								</thead>
        								<tbody>
        									{renderHTML(blankTDOrd)}
        									{/* {converter.convert(blankTDOrd)} */}
        								</tbody>
        							</table>
                    </TabPanel>
                     :this.props.positionData.OQFlag === true
        						? <TabPanel tabId="Orders" className="position-content">
        							<table id="ordertbl" className="reportsTbl">
        								<thead>
        									<tr>
                            <th className="reportsTblTh">{i18next.t('type')}</th>
                            <th className="reportsTblTh">{i18next.t('balance')}</th>
                            <th className="reportsTblTh">{i18next.t('price')}</th>
                            <th className="reportsTblTh">{i18next.t('currentVal')}</th>
        									</tr>
        								</thead>
        								<tbody>
        									{this.props.positionData.detOrderBeanMap?this.state.posOrderBeanMap.map((item, index) => {
                            var dec=this.getDec(item.suf_desc);
        										return (
        											<tr >
        												<td className="reportsTblTd">{this.props.dropdown.cmdty_metal.indexOf(item.suf_desc) !== -1 ? item.suf_desc + " " + this.props.userDetail.CompanyBaseName :item.suf_desc}</td>
        												<td className="reportsTblTd">{Number(parseFloat(item.fc_amt).toFixed(config.QuantityRoundOff)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })}</td>
                                						<td className="reportsTblTd">{Number(item.rate).toLocaleString(navigator.language,{ minimumFractionDigits: dec, maximumFractionDigits: dec })}</td>
        												<td className="reportsTblTd">{Number(parseFloat(item.amt).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF })}</td>
        											</tr>
        										);
        									}):null
        									}
        									{renderHTML(blankTDOrd)}
        									{/* {converter.convert(blankTDOrd)} */}
        								</tbody>
        							</table>
                      </TabPanel>
        						: <TabPanel tabId="Orders" className="position-content">
        							<table id="ordertbl" className="reportsTbl">
        								<thead>
        									<tr>
                            <th className="reportsTblTh">{i18next.t('type')}</th>
                            <th className="reportsTblTh">{i18next.t('balance')}</th>
                            <th className="reportsTblTh">{i18next.t('price')}</th>
                            <th className="reportsTblTh">{i18next.t('currentVal')}</th>
        									</tr>
        								</thead>
        								<tbody>
        									{renderHTML(blankTDOrd)}
        									{/* {converter.convert(blankTDOrd)} */}
        								</tbody>
        							</table>
                    </TabPanel>
        						}
                    {this.state.AccFlag ?
        						this.props.accBalMargBean.FOQFlag === true
        						? <TabPanel tabId="Fix" className="position-content">
        							<table id="ordertbl" className="reportsTbl">
        								<thead>
        									<tr>
                            <th className="reportsTblTh">{i18next.t('type')}</th>
                            <th className="reportsTblTh">{i18next.t('balance')}</th>
                            <th className="reportsTblTh">{i18next.t('price')}</th>
                            <th className="reportsTblTh">{i18next.t('currentVal')}</th>
        									</tr>
        								</thead>
        								<tbody>
        									{this.state.detFOBeanMap.map((item, index) => {
                            var dec=item.INSTID?this.getDecimal(item.INSTID):this.getDec(item.D);
        										return (
        											<tr >
        												<td className="reportsTblTd">{this.props.dropdown.cmdty_metal.indexOf(item.D) !== -1 ? item.D + " " + this.props.userDetail.CompanyBaseName :item.D}</td>
        												<td className="reportsTblTd">{Number(parseFloat(item.FQ).toFixed(config.QuantityRoundOff)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })}</td>
                    						<td className="reportsTblTd">{Number(item.STK_VAL.tick).toLocaleString(navigator.language,{ minimumFractionDigits: dec, maximumFractionDigits: dec })}</td>
        												<td className="reportsTblTd">{Number(parseFloat(item.STK_VAL.FO).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF })}</td>
        											</tr>
        										);
        									})
        									}
        									{renderHTML(blankTDFO)}
        									{/* {converter.convert(blankTDOrd)} */}
        								</tbody>
        							</table>
                    </TabPanel>
        						: <TabPanel tabId="Fix" className="position-content">
        							<table id="ordertbl" className="reportsTbl">
        								<thead>
        									<tr>
                            <th className="reportsTblTh">{i18next.t('type')}</th>
                            <th className="reportsTblTh">{i18next.t('balance')}</th>
                            <th className="reportsTblTh">{i18next.t('price')}</th>
                            <th className="reportsTblTh">{i18next.t('currentVal')}</th>
        									</tr>
        								</thead>
        								<tbody>
        									{renderHTML(blankTDFO)}
        									{/* {converter.convert(blankTDOrd)} */}
        								</tbody>
        							</table>
                    </TabPanel>
                     :this.props.positionData.FOQFlag === true
        						? <TabPanel tabId="Fix" className="position-content">
        							<table id="ordertbl" className="reportsTbl">
        								<thead>
        									<tr>
                            <th className="reportsTblTh">{i18next.t('type')}</th>
                            <th className="reportsTblTh">{i18next.t('balance')}</th>
                            <th className="reportsTblTh">{i18next.t('price')}</th>
                            <th className="reportsTblTh">{i18next.t('currentVal')}</th>
        									</tr>
        								</thead>
        								<tbody>
        									{this.props.positionData.detFOBeanMap?this.state.posFOBeanMap.map((item, index) => {
                            var dec=this.getDec(item.suf_desc);
        										return (
        											<tr >
        												<td className="reportsTblTd">{this.props.dropdown.cmdty_metal.indexOf(item.suf_desc) !== -1 ? item.suf_desc + " " + this.props.userDetail.CompanyBaseName :item.suf_desc}</td>
        												<td className="reportsTblTd">{Number(parseFloat(item.fc_amt).toFixed(config.QuantityRoundOff)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })}</td>
                    						<td className="reportsTblTd">{Number(item.rate).toLocaleString(navigator.language,{ minimumFractionDigits: dec, maximumFractionDigits: dec })}</td>
        												<td className="reportsTblTd">{Number(parseFloat(item.amt).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF })}</td>
        											</tr>
        										);
        									}):null
        									}
        									{renderHTML(blankTDFO)}
        									{/* {converter.convert(blankTDOrd)} */}
        								</tbody>
        							</table>
                      </TabPanel>
        						: <TabPanel tabId="Fix" className="position-content">
        							<table id="ordertbl" className="reportsTbl">
        								<thead>
        									<tr>
                            <th className="reportsTblTh">{i18next.t('type')}</th>
                            <th className="reportsTblTh">{i18next.t('balance')}</th>
                            <th className="reportsTblTh">{i18next.t('price')}</th>
                            <th className="reportsTblTh">{i18next.t('currentVal')}</th>
        									</tr>
        								</thead>
        								<tbody>
        									{renderHTML(blankTDFO)}
        									{/* {converter.convert(blankTDOrd)} */}
        								</tbody>
        							</table>
                    </TabPanel>
        						}
        						{this.state.AccFlag ? this.props.accBalMargBean.TQFlag === true
        						? <TabPanel tabId="Transit" className="position-content">
        							<table id="ordertbl" className="table reportsTbl">
        								<thead>
        									<tr>
                            <th className="reportsTblTh">{i18next.t('type')}</th>
                            <th className="reportsTblTh">{i18next.t('balance')}</th>
                            <th className="reportsTblTh">{i18next.t('price')}</th>
                            <th className="reportsTblTh">{i18next.t('currentVal')}</th>
        									</tr>
        								</thead>
        								<tbody>
        									{this.state.detTransitBeanMap.map((item, index) => {
                            var dec=item.INSTID?this.getDecimal(item.INSTID):this.getDec(item.D);
        										return (
        											<tr >
        												<td className="reportsTblTd">{this.props.dropdown.cmdty_metal.indexOf(item.D) !== -1 ? item.D + " " + this.props.userDetail.CompanyBaseName :item.D}</td>
        												<td className="reportsTblTd">{Number(item.TQ.toFixed(config.QuantityRoundOff)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })}</td>
                                <td className="reportsTblTd">{Number(item.STK_VAL.tick).toLocaleString(navigator.language,{ minimumFractionDigits: dec, maximumFractionDigits: dec })}</td>
        												<td className="reportsTblTd">{Number(item.STK_VAL.RT.toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF })}</td>
        											</tr>
        										);
        									})
        									}
        			 				{renderHTML(blankTDTransit)}
        									{/* {converter.convert(blankTDTransit)} */}
        								</tbody>
        							</table>
                    </TabPanel>
        						: null : this.props.positionData.TQFlag === true
                    ? <TabPanel tabId="Transit" className="position-content" >
                      <table id="ordertbl" className="table reportsTbl">
        								<thead>
        									<tr >
                            <th className="reportsTblTh">{i18next.t('type')}</th>
                            <th className="reportsTblTh">{i18next.t('balance')}</th>
                            <th className="reportsTblTh">{i18next.t('price')}</th>
                            <th className="reportsTblTh">{i18next.t('currentVal')}</th>
        									</tr>
        								</thead>
        								<tbody>
                          {this.props.positionData.detTransitBeanMap?this.state.posDetTransitBeanMap.map((item, index) => {
                            var dec=this.getDec(item.suf_desc);
                            return (
                              <tr >
                              <td className="reportsTblTd">{this.props.dropdown.cmdty_metal.indexOf(item.suf_desc) !== -1 ? item.suf_desc + " " + this.props.userDetail.CompanyBaseName :item.suf_desc}</td>
                              <td className="reportsTblTd">{Number(item.fc_amt.toFixed(config.QuantityRoundOff)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })}</td>
                              <td className="reportsTblTd">{Number(item.rate).toLocaleString(navigator.language,{ minimumFractionDigits: dec, maximumFractionDigits: dec })}</td>
                              <td className="reportsTblTd">{Number(item.amt.toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF })}</td>
                              </tr>
                            );
                          }):null
        								}
        								{renderHTML(blankTDTransit)}
                        {/* {converter.convert(blankTDTransit)} */}
        								</tbody>
                        </table>
                    </TabPanel>
                    : null}
        						{ this.state.AccFlag ? this.props.accBalMargBean.UQFlag === true
        						?<TabPanel tabId="Unallocated" className="position-content">
        							<table id="ordertbl" className="table reportsTbl">
        								<thead>
        									<tr>
                            <th className="reportsTblTh">{i18next.t('type')}</th>
                            <th className="reportsTblTh">{i18next.t('balance')}</th>
                            <th className="reportsTblTh">{i18next.t('price')}</th>
                            <th className="reportsTblTh">{i18next.t('currentVal')}</th>
        									</tr>
        								</thead>
        								<tbody>
        								{this.state.detUnallocBeanMap.map((item, index) => {
                          var dec=this.getDec(item.D);
                          return (
                            <tr >
                              <td className="reportsTblTd">{this.props.dropdown.cmdty_metal.indexOf(item.D) !== -1 ? item.D + " " + this.props.userDetail.CompanyBaseName :item.D}</td>
                              <td className="reportsTblTd">{Number(item.UQ.toFixed(config.QuantityRoundOff)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })}</td>
                              <td className="reportsTblTd">{Number(item.STK_VAL.tick).toLocaleString(navigator.language,{ minimumFractionDigits: dec, maximumFractionDigits: dec })}</td>
                              <td className="reportsTblTd">{Number(item.STK_VAL.RU.toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF })}</td>
                            </tr>
                          );
        								})
        								}
        								{renderHTML(blankTDUnallocate)}
        								{/* {converter.convert(blankTDUnallocate)} */}
        								</tbody>
        							</table>
                    </TabPanel>
        						: null : this.props.positionData.UQFlag === true
                    ? <TabPanel tabId="Unallocated" className="position-content">
                      <table id="ordertbl" className="table reportsTbl">
        								<thead>
        									<tr>
                            <th className="reportsTblTh">{i18next.t('type')}</th>
                            <th className="reportsTblTh">{i18next.t('balance')}</th>
                            <th className="reportsTblTh">{i18next.t('price')}</th>
                            <th className="reportsTblTh">{i18next.t('currentVal')}</th>
        									</tr>
        								</thead>
        								<tbody>
                          {this.props.positionData.detUnallocBeanMap?this.state.posDetUnallocBeanMap.map((item, index) => {
                            var dec=this.getDec(item.suf_desc);
                            return (
                              <tr >
                              <td className="reportsTblTd">{this.props.dropdown.cmdty_metal.indexOf(item.suf_desc) !== -1 ? item.suf_desc + " " + this.props.userDetail.CompanyBaseName :item.suf_desc}</td>
                              <td className="reportsTblTd">{Number(item.fc_amt.toFixed(config.QuantityRoundOff)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })}</td>
                              <td className="reportsTblTd">{Number(item.rate).toLocaleString(navigator.language,{ minimumFractionDigits: dec, maximumFractionDigits: dec })}</td>
                              <td className="reportsTblTd">{Number(item.amt.toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF })}</td>
                              </tr>
                            );
                          }):null
        								}
        								{renderHTML(blankTDUnallocate)}
        								{/* {converter.convert(blankTDUnallocate)} */}
        								</tbody>
                      </table>
                    </TabPanel>
                    : null}
                    <TabPanel tabId="Delivery" className="position-content">
        							<div className="table-responsive">
        								<table id="ordertbl" className="reportsTbl">
        									<thead>
        										<tr>
        											<th className="reportsTblTh">{i18next.t('type')}</th>
        											<th className="reportsTblTh">{i18next.t('balance')}</th>
                              <th className="reportsTblTh">{i18next.t('price')}</th>
                              <th className="reportsTblTh">{i18next.t('currentVal')}</th>
        										</tr>
        									</thead>
        									<tbody>
                          {this.state.AccFlag ? this.state.posPDBean.map((item, index) => {
                            if (this.state.posPDBean.map.length > 0) {
                              let dec = this.getDec(item.suf_desc);
                              return (
                                <tr >
                                  <td className="reportsTblTd">{this.props.dropdown.cmdty_metal.indexOf(item.D) !== -1 ? item.D + " " + this.props.userDetail.CompanyBaseName :item.D}</td>
                                  <td className="reportsTblTd">{Number(parseFloat(item.DQ)).toLocaleString(navigator.language,{ minimumFractionDigits: 3 })}</td>     
                                  <td className="reportsTblTd">{Number(item.STK_VAL.tick).toLocaleString(navigator.language,{ minimumFractionDigits: dec, maximumFractionDigits: dec })}</td>
                                  <td className="reportsTblTd">{Number(parseFloat(item.STK_VAL.DO).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF })}</td>
                                </tr>
                              );
                            }
                            }) : this.state.posPD.map((item, index) => {
                              let dec=this.getDec(item.suf_desc);
                              return (
                                <tr >
                                  <td className="reportsTblTd">{this.props.dropdown.cmdty_metal.indexOf(item.D) !== -1 ? item.D + " " + this.props.userDetail.CompanyBaseName :item.D}</td>
                                  <td className="reportsTblTd">{Number(parseFloat(item.DQ)).toLocaleString(navigator.language,{ minimumFractionDigits: 3 })}</td>     
                                  <td className="reportsTblTd">{Number(item.STK_VAL.tick).toLocaleString(navigator.language,{ minimumFractionDigits: dec, maximumFractionDigits: dec })}</td>
                                  <td className="reportsTblTd">{Number(parseFloat(item.STK_VAL.DO).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF })}</td>
                                </tr>
                              );
                            })
                          }                                              
        										{renderHTML(blankTDPos)}
        									</tbody>
        								</table>
        							</div>
                    </TabPanel>
                  </div>
                  <div>
                    <TabPanel tabId="Funds" className="fund-content" id="contentfund">
        							<div id="fundresponsivetbl">
        								<table id="fundtbl" className={`reportFundsTable reportsTbl`}>
        									<thead>
        										<tr>
        											<th className="reportsTblTh">{i18next.t('currency')}</th>
        											<th className="reportsTblTh">{i18next.t('value')}</th>
        										</tr>
        									</thead>
        									<tbody>
        										{this.state.AccFlag ? this.state.fundsbean.map((item, index) => {
                            if(this.state.fundsbean.map.length > 0){
                              //if(parseFloat(item.FCQ) > 0 || parseFloat(item.FCQ) < 0){
                                return (
                                  <tr >
                                    <td className="reportsTblTd">{item.C}</td>
                                    <td className="reportsTblTd">{Number(parseFloat(item.Q).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF })}</td>
                                  </tr>
                                );
                              //}
                            }
        										}) : this.state.posFunds.map((item, index) => {
                              if(this.state.fundsbean.map.length > 0){
                                if(parseFloat(item.fc_amt) > 0 || parseFloat(item.fc_amt) < 0){
                                  return (
                                    <tr >
                                      <td className="reportsTblTd">{item.suf_code}</td>
                                      <td className="reportsTblTd">{Number(parseFloat(item.fc_amt).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF })}</td>
                                    </tr>
                                  );
                                }
                              }else{
                                if(parseFloat(item.fc_amt) > 0 || parseFloat(item.fc_amt) < 0){
                                  return (
                                    <tr >
                                      <td className="reportsTblTd">{item.suf_code}</td>
                                      <td className="reportsTblTd">{Number(parseFloat(item.fc_amt).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF })}</td>
                                    </tr>
                                  );
                                }
                              }
        										})
        										}
        										{renderHTML(blankTDfund)}
        									</tbody>
        								</table>
        							</div>
                    </TabPanel>
                  </div>
              </Tabs>
            </div>
            <div className={`${styles.rightpositiondiv} ${this.props.language} rightPanel`} id="rightdivPosition">
                <div className="funds_div_2">
                    <div className="row">
                        <label className="col-xs-5 col-md-5" id="fundlabelwrap">
                        {i18next.t('totalFund')+" ("+this.props.localCurrency[0].basecurrency+")"}: </label>
                        <input type="text" className={totFundsfloat >0 ? `${styles.col6} ${styles.positiveValues} mrgnField`:`${styles.col6} ${styles.negativeValues} mrgnField`} value={totFundsArray} />
                    </div>
                    <div className="row">
                        <label className="col-xs-5 col-md-5" id="fundlabelwrap">
                        {i18next.t('revaluation')}: </label>
                        <input type="text" className={totrevalfloat >0 ? `${styles.col6} ${styles.positiveValues} mrgnField`:`${styles.col6} ${styles.negativeValues} mrgnField`} value={totrevalArray} />
                    </div>
                    <div className="row">
                        <label className="col-xs-5 col-md-5" id="fundlabelwrap">
                        {i18next.t('netEquity')}: </label>
                        <input type="text" className={netEquityfloat >0 ? `${styles.col6} ${styles.positiveValues} mrgnField`:`${styles.col6} ${styles.negativeValues} mrgnField`} value={netEquityArray} />
                    </div>
                    {this.props.userDetail.ELL === true ? <div className="row">
                        <label className="col-md-5" id="fundlabelwrap">
                        {i18next.t('lossLmt')}: </label>
                        <input type="text" className={`${styles.col6} mrgnField lossLmtField`} value={lossLimitArray} />
                    </div>:null}
                    <div className="row">
                        <label className="col-xs-5 col-md-5" id="fundlabelwrap">
                        {marginPerCentValue}: </label>
                        <input type="text" className={applMrgfloat >0 ? `${styles.col6} ${styles.positiveValues} mrgnField`:`${styles.col6} ${styles.negativeValues} mrgnField`} value={applMrgArray} />
                    </div>
                    <div className="row">
                        <label className={`${styles.freeeqtylbl} col-xs-5 col-md-5`} id="fundlabelwrap">
                        {Excess+" ("+this.props.localCurrency[0].basecurrency+")"}: </label>
                        <input type="text" className={excessfloat >0 ? `${styles.col6} ${styles.positiveValues} mrgnField`:`${styles.col6} ${styles.negativeValues} mrgnField`} value={excessArray} />
                    </div>
                    <div className="row" id="fund2lastdiv">
                        <label className="col-xs-5 col-md-5" id="fundlabelwrap">
                        {i18next.t('marginPerc')}: { this.props.userDetail.enableCustomerOrder && this.state.orderCheckbox===true?
                        <span>
                          <ReactTooltip id='withOrdTooltip' class='toolTip'>
                            <span>{i18next.t('withOrderTooltip')}</span>
                          </ReactTooltip>
                          <MUIIcon dataFor='withOrdTooltip' icon={'Star'} className={`${styles.withOrderIcon} withOrderIcon`} style={this.props.selectedCssColorTheme.iconColor}/>
                        </span>:null}</label>
                        <input type="text" className={mrgcheckValue ? `${styles.col7} ${styles.positiveValues} mrgnField`:`${styles.col7} ${styles.negativeValues} mrgnField`} value={totMarginPerc} readonly/>
                    </div>
                </div>
            </div>
        </div>
    </div>
     );
   }
 }
